import React from 'react';
import { Document, Page, Text, View } from '@react-pdf/renderer';
import styles from '../styles';
import { appNames, reportingStandards } from '../../constants';
import { HeaderOTCQB } from '../headers';
import { Footer } from '../components';
import Cover from '../pages/Cover';
import CompanyInfo from '../pages/CompanyInfo';
import ReportingStandards from '../pages/ReportingStandards';
import AdditionalServices from '../pages/AdditionalServices';
import EligibilityStandards from '../pages/EligibilityStandards';
import Officers from '../pages/Officers';
import Directors from '../pages/Directors';
import ControlPersonIndividual from '../pages/ControlPersonIndividual';
import ControlPersonCorpEntity from '../pages/ControlPersonCorpEntity';
import SPTransferAgent from '../pages/SPTransferAgent';
import SPAuditor from '../pages/SPAuditor';
import SPSecCounsel from '../pages/SPSecCounsel';
import SPCorpBroker from '../pages/SPCorpBroker';
import SPInvestorRelationsServices from '../pages/SPInvestorRelationsServices';
import SPInvestmentBank from '../pages/SPInvestmentBank';
import SecurityDetails from '../pages/SecurityDetails';
import SecurityOwnership from '../pages/SecurityOwnership';
import LegalDisciplinaryHistory from '../pages/LegalDisciplinaryHistory';
import PrimaryContacts from '../pages/PrimaryContacts';
import AuthorizedUsers from '../pages/AuthorizedUsers';
import BillingContacts from '../pages/BillingContacts';
import BackgroundCheck from '../pages/BackgroundCheck';
import SuppDocsRequired from '../pages/SuppDocsRequired';
import SuppDocsAdditional from '../pages/SuppDocsAdditional';
import PaymentDetails from '../pages/PaymentDetails';

const OTCQB = appNames.OTCQB;

const TemplateOTCQB = ({ application, documents, owners, docTypes, appStates }) => {
  const status = application && application.status;
  const appStateObj = appStates && appStates.find(state => state.stateId === status);
  const statusDesc = appStateObj && appStateObj.description || application.status;
  const symbol = application && application.primarySymbol;
  const companyName = application && application.companyInfo && application.companyInfo.name;
  const isIntlReportStnd = application && application.reportingStandard === reportingStandards.INTERNATIONAL;
  const draftMgCertRequired = !isIntlReportStnd;

  return (
    <Document style={styles.document} >
      <Page style={styles.page} size='A4'>
        <HeaderOTCQB />
        <Cover type={OTCQB} status={statusDesc} symbol={symbol} symbolType={'OTCQB'} companyName={companyName} owners={owners} people={application.peopleList} />
        <Footer companyName={companyName} />
      </Page>
      <Page style={styles.page} size='A4'>
        <HeaderOTCQB />
        <CompanyInfo data={application.companyInfo} type={OTCQB} />
        <Footer companyName={companyName} />
      </Page>
      <Page style={styles.page} size='A4'>
        <HeaderOTCQB />
        <EligibilityStandards data={application.eligibilityStandards} type={OTCQB} reportingStandard={application.reportingStandard} />
        <Footer companyName={companyName} />
      </Page>
      <Page style={styles.page} size='A4'>
        <HeaderOTCQB />
        <ReportingStandards data={application.reportingStandard} detail={application.reportingStandardDetail} cik={application.cikNumber} />
        <Footer companyName={companyName} />
      </Page>
      <Page style={styles.page} size='A4'>
        <HeaderOTCQB />
        <Officers data={application.peopleList} />
        <Footer companyName={companyName} />
      </Page>
      <Page style={styles.page} size='A4'>
        <HeaderOTCQB />
        <Directors data={application.peopleList} />
        <Footer companyName={companyName} />
      </Page>
      <Page style={styles.page} size='A4'>
        <HeaderOTCQB />
        <ControlPersonIndividual data={application.peopleList} />
        <Footer companyName={companyName} />
      </Page>
      <Page style={styles.page} size='A4'>
        <HeaderOTCQB />
        <ControlPersonCorpEntity entities={application.corporateEntityList} people={application.peopleList} />
        <Footer companyName={companyName} />
      </Page>
      <Page style={styles.page} size='A4'>
        <HeaderOTCQB />
        <SecurityDetails data={application.securityDetails} type={OTCQB} />
        <Footer companyName={companyName} />
      </Page>
      <Page style={styles.page} size='A4'>
        <HeaderOTCQB />
        <SecurityOwnership people={application.peopleList} entities={application.corporateEntityList} securities={application.securityDetails && application.securityDetails.securityList} />
        <Footer companyName={companyName} />
      </Page>
      <Page style={styles.page} size='A4'>
        <HeaderOTCQB />
        <LegalDisciplinaryHistory data={application.legalHistory} />
        <Footer companyName={companyName} />
      </Page>
      <Page style={styles.page} size='A4'>
        <HeaderOTCQB />
        <PrimaryContacts data={application.peopleList} />
        <Footer companyName={companyName} />
      </Page>
      <Page style={styles.page} size='A4'>
        <HeaderOTCQB />
        <AuthorizedUsers data={application.peopleList} />
        <Footer companyName={companyName} />
      </Page>
      <Page style={styles.page} size='A4'>
        <HeaderOTCQB />
        <BillingContacts data={application.peopleList} />
        <Footer companyName={companyName} />
      </Page>
      <Page style={styles.page} size='A4'>
        <HeaderOTCQB />
        <BackgroundCheck type={OTCQB} people={application.peopleList} entities={application.corporateEntityList} />
        <Footer companyName={companyName} />
      </Page>
      <Page style={styles.page} size='A4'>
        <HeaderOTCQB />
        <SPTransferAgent data={application.transferAgents} />
        <Footer companyName={companyName} />
      </Page>
      <Page style={styles.page} size='A4'>
        <HeaderOTCQB />
        <SPAuditor data={application.auditors} />
        <Footer companyName={companyName} />
      </Page>
      <Page style={styles.page} size='A4'>
        <HeaderOTCQB />
        <SPSecCounsel data={application.securitiesCounsels} />
        <Footer companyName={companyName} />
      </Page>
      <Page style={styles.page} size='A4'>
        <HeaderOTCQB />
        <SPCorpBroker data={application.corporateBroker} />
        <Footer companyName={companyName} />
      </Page>
      <Page style={styles.page} size='A4'>
        <HeaderOTCQB />
        <SPInvestorRelationsServices data={application.investorRelations} />
        <Footer companyName={companyName} />
      </Page>
      <Page style={styles.page} size='A4'>
        <HeaderOTCQB />
        <SPInvestmentBank data={application.investmentBanks} />
        <Footer companyName={companyName} />
      </Page>
      <Page style={styles.page} size='A4'>
        <HeaderOTCQB />
        <SuppDocsRequired docs={documents} docTypes={docTypes} shareHoldRequired auditAnnualReportRequired draftMgCertRequired={draftMgCertRequired} />
        <Footer companyName={companyName} />
      </Page>
      <Page style={styles.page} size='A4'>
        <HeaderOTCQB />
        <SuppDocsAdditional docs={documents} docTypes={docTypes} shareHoldRequired auditAnnualReportRequired draftMgCertRequired={draftMgCertRequired} />
        <Footer companyName={companyName} />
      </Page>
      <Page style={styles.page} size='A4'>
        <HeaderOTCQB />
        <AdditionalServices data={application.additionalServices} hasBluesky hasVIC />
        <Footer companyName={companyName} />
      </Page>
      { application.payment && <Page style={styles.page} size='A4'>
        <HeaderOTCQB />
        <PaymentDetails data={application.payment} submitDate={application.submitDate} />
        <Footer companyName={companyName} />
      </Page> }
    </Document>
  );
};

export default TemplateOTCQB;
